// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38P8h","col":"styles_col__2TK5_"};